import styled from 'vue-styled-components';

const theme = { borderRadius: Number};

const ThemedEventInfo = styled('div', theme)`
    border-bottom-left-radius: ${props => +props.borderRadius}px;
    border-bottom-right-radius: ${props => +props.borderRadius}px;
    background: #fff;
    padding: 15px;
    position: relative;
    z-index: 3;
    margin-bottom: -10px;    
`;

export default ThemedEventInfo
